import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const FieldDate = ({
  id,
  label,
  value,
  handleChange,
  readOnly,
  required,
  styles,
  showTooltip = false,
  titleWeight = "normal", // "bold" | "semibold" | "normal"
}) => {
  const editing = !readOnly;
  const valueSplit = value.split("-");
  const empty = valueSplit[0] === "" || valueSplit[0] === "0001";
  const visibleValue = empty
    ? ""
    : `${valueSplit[2]}/${valueSplit[1]}/${valueSplit[0]}`;

  return (
    <S.Container>
      {label && <S.Title $weight={titleWeight}>{label}</S.Title>}
      <S.InputContainer title={showTooltip ? value : ""}>
        <S.InputWrapper className={editing ? "visible" : "hidden"}>
          <S.Input
            name={id}
            type="date"
            value={empty ? "" : value}
            onChange={(e) => handleChange(id, e.target.value)}
            readOnly={readOnly}
            required={required}
            styles={styles}
          />
        </S.InputWrapper>
        <S.Text className={editing ? "hidden" : "visible"}>
          {visibleValue}
        </S.Text>
      </S.InputContainer>
    </S.Container>
  );
};

FieldDate.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  handleChange: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  styles: PropTypes.string,
};
